import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SelfTruncatingPathModule } from '@portal-core/general/components/self-truncating-path/self-truncating-path.module';
import { ProjectFilesTreeModule } from '@portal-core/project-files/components/project-files-tree/project-files-tree.module';
import { ProjectFilePickerInputItemModule } from '@portal-core/project-files/directives/project-file-picker-input-item/project-file-picker-input-item.module';
import { ProjectFilesTreeItemModule } from '@portal-core/project-files/directives/project-files-tree-item/project-files-tree-item.module';
import { RemoveLeadingSlashModule } from '@portal-core/project-files/pipes/remove-leading-slash/remove-leading-slash.module';
import { ClickModule } from '@portal-core/ui/clicking/directives/click/click.module';
import { DropdownArrowModule } from '@portal-core/ui/forms/components/dropdown-arrow/dropdown-arrow.module';
import { PopupModule } from '@portal-core/ui/popup/popup.module';
import { WorkspaceTreeModule } from '@portal-core/workspaces/directives/workspace-tree/workspace-tree.module';
import { ProjectFilePickerInputComponent } from './project-file-picker-input.component';

@NgModule({
  declarations: [
    ProjectFilePickerInputComponent
  ],
  imports: [
    ClickModule,
    CommonModule,
    DropdownArrowModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    WorkspaceTreeModule,
    PopupModule,
    ProjectFilesTreeModule,
    ProjectFilePickerInputItemModule,
    RemoveLeadingSlashModule,
    SelfTruncatingPathModule
  ],
  exports: [
    ProjectFilePickerInputComponent,
    ProjectFilePickerInputItemModule,
    ProjectFilesTreeItemModule
  ]
})
export class ProjectFilePickerInputModule { }
